// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T14:57:50.621Z
// Property: Cedar Lane and Garden Glen (ID: 6767906449166885)
// Collections: 15 amenities, 9 floorplans (live), 28 photos, 43 POIs, 1 reviews, 2 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166885",
  "property_external_id": "495883",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/cedar-lane-and-garden-glen-portland-or/wjvv2qj/",
  "property_google_business_url": "https://www.google.com/maps/place/Cedar+Lane+Apartments/data=!4m2!3m1!1s0x0:0x5e9238c298643bb8?sa=X&ved=2ahUKEwjEvrn9hbySAxXDKFkFHSPBBhAQ_BJ6BAgQEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495883 p0505551",
  "property_status": null,
  "property_slug": "cedar-lane-and-garden-glen",
  "property_name": "Cedar Lane and Garden Glen",
  "property_website_url": "www.apartments-portland-oregon.com",
  "property_domain": "https://www.apartments-portland-oregon.com/",
  "property_address": "7600 SW Oleson Rd #8",
  "property_full_address": "7600 SW Oleson Rd #8, Portland, OR, 97223",
  "property_address_1": "7600 SW Oleson Rd #8",
  "property_address_2": "8",
  "property_address_city": "Portland",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97223",
  "property_address_country": "US",
  "property_address_county": "Washington County",
  "property_neighborhood_address": "Ashcreek",
  "property_address_latitude": "45.4648",
  "property_address_longitude": "-122.7543",
  "property_email": "cedarlane@ctlmanagement.com",
  "property_phone": "18339235827",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Cedar Lane/Garden Glen in vibrant Portland, OR, where stylish one, two, and three-bedroom apartments await. Enjoy modern amenities like high-speed internet, convenient laundry facilities, and inviting patios. Experience community living at its finest—schedule a tour today and secure your perfect home!",
  "property_long_description": "Welcome to Cedar Lane/Garden Glen, your ideal apartment community nestled in the heart of vibrant Portland, OR. With a diverse range of floor plans to suit every lifestyle, we offer spacious one-bedroom, two-bedroom, and three-bedroom apartments designed for comfort and convenience. Each unit boasts modern amenities and thoughtful details to enhance your living experience. \n\nEnjoy a relaxed, smoke-free environment with abundant natural light, fully-equipped kitchens featuring dishwashers and pantries, and private outdoor spaces—some with balconies or patios perfect for unwinding at the end of the day. Our community is equipped with high-speed internet access to keep you connected and on-the-go, while the in-building laundry facilities make chores a breeze.\n\nOutdoor enthusiasts will appreciate our grilling area, perfect for summer barbecues with friends and family. Plus, with easy access to public transportation, exploring everything Portland has to offer has never been easier!\n\nAt Cedar Lane/Garden Glen, we strive to provide a seamless living experience. Take advantage of our online services, designed to make your life more convenient. Whether you’re relaxing on your balcony or enjoying a cookout in the grilling area, you’ll love the sense of community and comfort our setting provides.\n\nFind your new home today! Browse our availability or schedule a tour to visit our welcoming community at Cedar Lane/Garden Glen. Discover your next chapter in Portland, where comfort meets convenience.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-9239-750d-8c25-15534169db72.webp",
  "property_featured_image_media": {
    "alt_text": "Apartment building exterior with balconies, grassy lawn, picnic table, and grill.",
    "public_id": "019d1c25-9239-750d-8c25-15534169db72",
    "storage_key": "property/6767906449166885/019d1c25-9239-750d-8c25-15534169db72.webp",
    "width": 2048,
    "height": 1503
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "95",
  "property_year_built": "1976",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.73684210526315",
  "property_admin_fee": null,
  "property_application_fee": "22",
  "property_fees_deposit_info": "Security Deposit (Refundable): $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $25 | Deposit $400",
  "property_online_leasing_url": "https://apartments-portland-oregon.securecafe.com/onlineleasing/cedar-lane-garden-glen/floorplans.aspx",
  "property_resident_portal_url": "https://apartments-portland-oregon.securecafe.com/residentservices/cedar-lane-garden-glen/userlogin.aspx",
  "property_apply_now_url": "https://apartments-portland-oregon.securecafe.com/onlineleasing/cedar-lane-garden-glen/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d73c6-8977-721f-ab71-f060ee1903f2.webp",
  "property_primary_logo_media": {
    "alt_text": "Cedar Lane & Garden Glen Apartments logo.",
    "public_id": "019d73c6-8977-721f-ab71-f060ee1903f2",
    "storage_key": "property/6767906449166885/019d73c6-8977-721f-ab71-f060ee1903f2.webp",
    "width": 1307,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d73c6-899d-7060-822c-a3a50502aae5.webp",
  "property_secondary_logo_media": {
    "alt_text": "Cedar Lane & Garden Glen Apartments logo.",
    "public_id": "019d73c6-899d-7060-822c-a3a50502aae5",
    "storage_key": "property/6767906449166885/019d73c6-899d-7060-822c-a3a50502aae5.webp",
    "width": 1304,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019de0b2-cd59-74d8-821a-ff490b748070.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Blank image",
    "public_id": "019de0b2-cd59-74d8-821a-ff490b748070",
    "storage_key": "property/6767906449166885/019de0b2-cd59-74d8-821a-ff490b748070.webp",
    "width": 1280,
    "height": 156
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019de0b2-c067-750a-8108-cb44c0b4149c.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Black square",
    "public_id": "019de0b2-c067-750a-8108-cb44c0b4149c",
    "storage_key": "property/6767906449166885/019de0b2-c067-750a-8108-cb44c0b4149c.webp",
    "width": 1280,
    "height": 156
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "476 - 1016",
  "property_sqft_min": "476",
  "property_sqft_max": "1016",
  "property_price_range": "1175 - 1680",
  "property_price_min": "1175",
  "property_price_max": "1680",
  "property_available_units": 13,
  "property_facebook_url": "https://www.facebook.com/cedarlanegardenglenapartmenthomes/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJTaNyiXwMlVQRuDtkmMI4kl4",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/cedar-lane-and-garden-glen-apartments-portland-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cedar Lane/Garden Glen",
  "property_home_romance_title": "Embrace Life and Love at Your New Apartment Home",
  "property_home_amenities_blurb": "At Cedar Lane/Garden Glen in vibrant Portland, OR, your perfect home awaits. Choose from spacious one, two, or three-bedroom floor plans, each designed for comfort. Enjoy modern amenities like high-speed internet, a smoke-free environment, and inviting communal spaces. Embrace the lifestyle you deserve—make Cedar Lane your new home today!",
  "property_home_floorplans_blurb": "Welcome to Cedar Lane/Garden Glen in vibrant Portland, OR, where your dream apartment awaits! With a variety of thoughtfully designed floor plans, we cater to your unique lifestyle. Browse our available homes today and embrace a community that combines comfort, style, and urban convenience—your perfect living space is just a click away!",
  "property_home_gallery_blurb": "Welcome to Cedar Lane/Garden Glen in vibrant Portland, OR, where comfort meets convenience. Our thoughtfully designed one, two, and three-bedroom apartments offer modern amenities like high-speed internet, smoke-free living, and inviting patios. Imagine weekends grilling with friends or enjoying easy access to public transport. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Cedar Lane/Garden Glen in vibrant Portland, OR, where spacious one to three-bedroom apartments meet a treasure trove of local attractions. Immerse yourself in culture at Powell's City of Books, relax at the stunning Portland Japanese Garden, or enjoy a day of discovery at the Oregon Zoo—adventure awaits right outside your door!",
  "property_home_reviews_blurb": "At Cedar Lane/Garden Glen in Portland, OR, residents rave about their vibrant community, saying, “It feels like home the moment you step in!” Experience comfort and connection in a place where friendly neighbors and lush surroundings enhance your lifestyle. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Nestled in the vibrant heart of Portland, Cedar Lane/Garden Glen connects you to an array of cultural gems. Enjoy serene strolls through the Portland Japanese Garden, delve into literary wonders at Powell's City of Books, or embrace nature at Hoyt Arboretum. Check out the surrounding treasures and enrich your lifestyle today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cedar Lane/Garden Glen in Portland, OR, comfort meets convenience. Choose from one, two, or three-bedroom floor plans designed for modern living. Enjoy amenities like high-speed internet, a vibrant grill area, and smoke-free balconies. Experience a life where every detail enhances your daily routine. Join our welcoming community today!",
  "property_applynow_blurb": "At Cedar Lane/Garden Glen in Portland, OR, we offer a variety of thoughtfully designed one, two, and three-bedroom apartments. Enjoy modern amenities like high-speed internet, a convenient grill area, and smoke-free living. Lease online today and step into your perfect new home, tailored for comfort and convenience!",
  "property_contactus_blurb": "At Cedar Lane/Garden Glen in Portland, OR, our diverse floor plans—one, two, and three-bedroom options—are designed to suit your lifestyle. Each space blends comfort and modern living. Have questions? Contact our leasing team today for personalized assistance in finding your perfect home!",
  "property_faqs_blurb": "At Cedar Lane/Garden Glen in vibrant Portland, OR, we offer an array of thoughtfully designed floor plans: one, two, and three-bedroom homes tailored for your lifestyle. Have questions? Our FAQs page is your go-to resource for everything you need to know about our welcoming community.",
  "property_floorplans_blurb": "At Cedar Lane/Garden Glen in Portland, OR, our thoughtfully designed floor plans cater to every lifestyle. Choose from cozy one-bedroom retreats, spacious two-bedroom haven, or expansive three-bedroom layouts. Each home promises comfort and style, ensuring a perfect fit for your needs. Browse our available apartment homes today!",
  "property_gallery_blurb": "Imagine stepping into your dream home at Cedar Lane/Garden Glen in vibrant Portland, OR. Our spacious one, two, and three-bedroom apartments feature modern kitchens, private balconies, and convenient amenities like laundry facilities and high-speed internet. Picture yourself relaxing by the grill or utilizing hassle-free online services—your perfect lifestyle awaits!",
  "property_interactivemap_blurb": "At Cedar Lane/Garden Glen in vibrant Portland, OR, your ideal apartment awaits. Choose from spacious one, two, or three-bedroom floor plans, complete with modern amenities like high-speed internet, balconies, and smoke-free living. Embrace convenience with our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Cedar Lane/Garden Glen in vibrant Portland, OR, your furry friends are cherished! Bring home two indoor adult cats or dogs, each up to 25 lbs, and enjoy a pet-friendly community. Small caged companions can join too, making your apartment feel truly like home. Embrace life with your pets in comfort!",
  "property_referafriend_blurb": "At Cedar Lane/Garden Glen in vibrant Portland, OR, our diverse floor plans—one, two, and three bedrooms—offer comfort for every lifestyle. Embrace community living where great friends become great neighbors. Share the joy of home today and refer a friend to start their journey with us!",
  "property_residentaccess_blurb": "Welcome to Cedar Lane/Garden Glen in vibrant Portland, OR! Our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Access your resident portal now to effortlessly pay rent, schedule maintenance, and stay connected with your community. Your ideal living experience awaits at Cedar Lane/Garden Glen!",
  "property_reviews_blurb": "At Cedar Lane/Garden Glen in Portland, OR, our residents rave about their home: “A peaceful retreat with beautiful surroundings and friendly neighbors.” Experience the charm and community spirit that make living here truly special. Uncover more sentiments from our satisfied residents—see what they have to say about life at Cedar Lane!",
  "property_created_at": "1762784737074",
  "property_scheduletour_blurb": "Nestled in the heart of Portland, Cedar Lane/Garden Glen offers thoughtfully designed one, two, and three-bedroom floor plans tailored for modern living. Experience vibrant community life and beautiful surroundings. Schedule a tour today and hear firsthand from our residents about why they love calling this place home!",
  "property_thankyou_blurb": "Thank you for reaching out to Cedar Lane/Garden Glen in vibrant Portland, OR! Our community offers thoughtfully designed one, two, and three-bedroom floor plans to suit your lifestyle. Expect to hear from us soon—your new home awaits just around the corner!",
  "property_virtualtours_blurb": "Welcome to Cedar Lane/Garden Glen in vibrant Portland, OR! With spacious one, two, and three-bedroom floor plans, your perfect home awaits. Experience modern living complemented by lush scenery. Take a virtual tour today and step inside your future sanctuary!",
  "property_copyright": "2025 All Rights Reserved. Cedar Lane/Garden Glen",
  "property_seo_title_home": "Cedar Lane/Garden Glen |  Apartments in Portland, OR",
  "property_seo_description_home": "Experience Portland living at Cedar Lane/Garden Glen. Choose from spacious one, two, or three-bedroom layouts with modern amenities. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Portland, OR Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Cedar Lane/Garden Glen in Portland, OR. Choose from stylish one, two, or three-bedroom floor plans to suit your lifestyle!",
  "property_seo_title_amenities": "Amenities | Portland, OR Apartments for Rent",
  "property_seo_description_amenities": "Experience Cedar Lane/Garden Glen in Portland! Enjoy spacious floor plans, modern amenities, and a smoke-free environment. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Portland, OR",
  "property_seo_description_gallery": "Capture your dream lifestyle at Cedar Lane/Garden Glen in Portland, OR. With stunning floor plans and upscale amenities, envision your perfect home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Cedar Lane/Garden Glen Apartments",
  "property_seo_description_virtualtours": "Step inside Cedar Lane/Garden Glen in Portland, OR! Experience our one, two, and three-bedroom apartments through a captivating virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Cedar Lane/Garden Glen Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Cedar Lane/Garden Glen in Portland, OR! Browse our interactive map for available apartments, amenities, and pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Portland, OR",
  "property_seo_description_neighborhood": "Uncover the charm of Cedar Lane/Garden Glen in Portland, OR. Dive into local favorites and hidden gems around our vibrant community!",
  "property_seo_title_contact": "Contact Us | Cedar Lane/Garden Glen",
  "property_seo_description_contact": "Connect with Cedar Lane/Garden Glen in Portland, OR! Inquire about our one, two, and three-bedroom layouts. Your perfect home awaits—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Portland, OR",
  "property_seo_description_faqs": "Find quick answers about Cedar Lane/Garden Glen in Portland, OR! Explore FAQs on floor plans, amenities, and more to embrace your new home experience.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Portland, OR",
  "property_seo_description_reviews": "Experience life at Cedar Lane/Garden Glen in Portland, OR! Check out our resident reviews to see why our community is the perfect place to call home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Portland, OR",
  "property_seo_description_applynow": "Discover your ideal home at Cedar Lane/Garden Glen in Portland, OR! Modern amenities, spacious layouts, and a smoke-free environment await.",
  "property_seo_title_residentaccess": "Resident Access | Cedar Lane/Garden Glen",
  "property_seo_description_residentaccess": "Enjoy convenience at Cedar Lane/Garden Glen! Log in to your portal for rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Cedar Lane/Garden Glen",
  "property_seo_description_referafriend": "Refer a friend to Cedar Lane/Garden Glen in Portland, OR! Great friends make great neighbors—invite them to share in our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cedar Lane/Garden Glen",
  "property_seo_description_scheduletour": "Experience the charm of Cedar Lane/Garden Glen in Portland, OR. Schedule your tour today and uncover the perfect blend of comfort and community!",
  "property_seo_title_privacy": "Privacy Policy | Cedar Lane/Garden Glen",
  "property_seo_description_privacy": "Protecting your privacy is our priority at Cedar Lane/Garden Glen. Learn how we safeguard your data while you enjoy life in beautiful Portland. Read more!",
  "property_seo_title_accessibility": "Website Accessibility | Cedar Lane/Garden Glen",
  "property_seo_description_accessibility": "Experience true accessibility at Cedar Lane/Garden Glen in Portland, OR. Join our commitment to digital inclusion and discover a welcoming community for all.",
  "property_seo_title_sitemap": "Sitemap | Cedar Lane/Garden Glen",
  "property_seo_description_sitemap": "Navigate life at Cedar Lane/Garden Glen in Portland, OR. Our sitemap unveils your future home—discover amenities, layouts, and vibrant community features!",
  "property_seo_title_thankyou": "Thank You | Cedar Lane/Garden Glen",
  "property_seo_description_thankyou": "Thank you for reaching out! A Cedar Lane/Garden Glen team member will connect with you soon to help you find your perfect Portland apartment oasis.",
  "property_seo_title_pets": "Pet Policy | Apartments in Portland, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293640595",
  "amenities": [
    {
      "id": "ec_78b8f1fad82fedff4d5b204e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "80798734",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c26-0bf7-729e-ae53-ed802dab4f47.webp",
      "amenity_image_media": {
        "alt_text": "Laundry room with multiple washers and dryers.",
        "public_id": "019d1c26-0bf7-729e-ae53-ed802dab4f47",
        "storage_key": "property/6767906449166885/019d1c26-0bf7-729e-ae53-ed802dab4f47.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Laundry Room at Cedar Lane and Garden Glen, Portland, Oregon",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4bf69ea4c10ab54ef1cd410",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "80428655",
      "title": "Direct Access to TriMet Bus Line 45 (Garden Home/Arnold Creek)",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22715e590f22327466bbb431",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "80683680",
      "title": "Picnic & BBQ Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-9239-750d-8c25-15534169db72.webp",
      "amenity_image_media": {
        "alt_text": "Apartment building exterior with balconies, grassy lawn, picnic table, and grill.",
        "public_id": "019d1c25-9239-750d-8c25-15534169db72",
        "storage_key": "property/6767906449166885/019d1c25-9239-750d-8c25-15534169db72.webp",
        "width": 2048,
        "height": 1503
      },
      "amenity_image_alt_text": "Picnic Area at Cedar Lane and Garden Glen, Portland",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16ff370ee3ffa6b5e885b62f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "86393176",
      "title": "Package Acceptance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_932cd26c438cf8f24d2e5478",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "86393174",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_974e504dfce38067a0f7109e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "86393177",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5a95414365a97a6c868fe5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "80428654",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3bfcb1ddd356cbf1bd4d96b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "82390133",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e29fb7c8c395538ab4992b86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "82390135",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d4f9c4948a80ef6faeb3d94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "87350804",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-b39e-7609-bc05-4a8063f98897.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with dark wood cabinets, a double sink, dishwasher, and white refrigerator.",
        "public_id": "019d1c25-b39e-7609-bc05-4a8063f98897",
        "storage_key": "property/6767906449166885/019d1c25-b39e-7609-bc05-4a8063f98897.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Upgraded Kitchen at Cedar Lane and Garden Glen, Portland, Oregon,Kitchen & Dining Room at Cedar Lane and Garden Glen, Portland, OR, 97223",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33cdd5313fd1df91957e3a54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "87350803",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_363384fa4f5dd1a1c7f7671c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "87350805",
      "title": "Electric Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48e0883c9dec737a6fb58fde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "127432708",
      "title": "Assigned Parking",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb55b1c47ac9b14795009930",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "87310401",
      "title": "Kitchen Pantry - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1bf5-35a7-749b-bd7a-61637aab79ba.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with wooden cabinets, white refrigerator, and white stove.",
        "public_id": "019d1bf5-35a7-749b-bd7a-61637aab79ba",
        "storage_key": "property/6767906449166885/019d1bf5-35a7-749b-bd7a-61637aab79ba.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Upgraded Kitchen & Pantry at Cedar Lane and Garden Glen, Oregon, 97223",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53f95f87b5b7189c2dce58c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "yardi",
      "external_id": "80428659",
      "title": "Energy Efficient Windows - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c00-9b1b-742c-a4fe-382f2ea0d76d.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with white refrigerator, dishwasher, sink, and dark wood cabinets.",
        "public_id": "019d1c00-9b1b-742c-a4fe-382f2ea0d76d",
        "storage_key": "property/6767906449166885/019d1c00-9b1b-742c-a4fe-382f2ea0d76d.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Kitchen & Window at Cedar Lane and Garden Glen, Portland, OR, 97223",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_bf2f75f491fd638a21834b70",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c00-9bdf-75b9-81d9-74cacc253086.webp",
      "image_media": {
        "alt_text": "Garden Glen Apartments monument sign and building exterior.",
        "public_id": "019d1c00-9bdf-75b9-81d9-74cacc253086",
        "storage_key": "property/6767906449166885/019d1c00-9bdf-75b9-81d9-74cacc253086.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Welcome to Garden Glen Apartments, featuring a monument sign with the property's name and address, alongside the building exterior with a leasing office entrance.",
      "link": "false",
      "alt_text": "Garden Glen Apartments monument sign and building exterior.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_Leasing Office.jpg"
    },
    {
      "id": "ec_98284e65e8abd5c281807bf6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-9237-71ac-ba7e-d04fcf8890f9.webp",
      "image_media": {
        "alt_text": "Garden Glen Apartments exterior signage and building entrance.",
        "public_id": "019d1c25-9237-71ac-ba7e-d04fcf8890f9",
        "storage_key": "property/6767906449166885/019d1c25-9237-71ac-ba7e-d04fcf8890f9.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Welcome to Garden Glen Apartments, featuring a prominent monument sign and a clean, inviting building exterior with a leasing office.",
      "link": "false",
      "alt_text": "Garden Glen Apartments exterior signage and building entrance.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_Leasing OfficeMonumentSign.jpg"
    },
    {
      "id": "ec_25abf91357d1fdbc626c38d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-9238-72ae-8e22-1a313781893d.webp",
      "image_media": {
        "alt_text": "Exterior of Garden Glen Apartments building with trees and signage.",
        "public_id": "019d1c25-9238-72ae-8e22-1a313781893d",
        "storage_key": "property/6767906449166885/019d1c25-9238-72ae-8e22-1a313781893d.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Exterior view of the Garden Glen Apartments complex, featuring the main building, landscaping, and signage. Discover comfortable living at Garden Glen.",
      "link": "false",
      "alt_text": "Exterior of Garden Glen Apartments building with trees and signage.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_Street View.jpg"
    },
    {
      "id": "ec_a01bc84132dec36c5ab8209d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-9491-76c9-9458-80d406ce9d85.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with stone accents, dark siding, and beige siding.",
        "public_id": "019d1c25-9491-76c9-9458-80d406ce9d85",
        "storage_key": "property/6767906449166885/019d1c25-9491-76c9-9458-80d406ce9d85.webp",
        "width": 2048,
        "height": 1505
      },
      "title": "Community",
      "description": "A view of the exterior of the apartment building, showcasing its unique stone and siding facade, with balconies and staircases visible. Surrounded by greenery and a paved walkway.",
      "link": "false",
      "alt_text": "Exterior view of a multi-story apartment building with stone accents, dark siding, and beige siding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_Building Entries.jpg"
    },
    {
      "id": "ec_1f5af11e3b2f111c896382ef",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-9239-750d-8c25-15534169db72.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with balconies, grassy lawn, picnic table, and grill.",
        "public_id": "019d1c25-9239-750d-8c25-15534169db72",
        "storage_key": "property/6767906449166885/019d1c25-9239-750d-8c25-15534169db72.webp",
        "width": 2048,
        "height": 1503
      },
      "title": "Community",
      "description": "Enjoy outdoor living with community grills and picnic areas right outside your door. Relax on your private balcony or take in the lush green surroundings.",
      "link": "false",
      "alt_text": "Apartment building exterior with balconies, grassy lawn, picnic table, and grill.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_Picnic Area.jpg"
    },
    {
      "id": "ec_0e15fca0a05563b8a669acbb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-9bdc-70cb-93f0-d76878176ff5.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with balconies, grass, trees, and a picnic area.",
        "public_id": "019d1c25-9bdc-70cb-93f0-d76878176ff5",
        "storage_key": "property/6767906449166885/019d1c25-9bdc-70cb-93f0-d76878176ff5.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Experience comfortable living in this apartment building featuring attractive exteriors, private balconies, and community amenities like picnic areas and lush green spaces.",
      "link": "false",
      "alt_text": "Apartment building exterior with balconies, grass, trees, and a picnic area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_BBQ.jpg"
    },
    {
      "id": "ec_96045538304ab0d030a60dca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1bf5-35a7-749b-bd7a-61637aab79ba.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white refrigerator, and white stove.",
        "public_id": "019d1bf5-35a7-749b-bd7a-61637aab79ba",
        "storage_key": "property/6767906449166885/019d1bf5-35a7-749b-bd7a-61637aab79ba.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "A functional kitchen space featuring wooden cabinetry, a white refrigerator, and a white stove, perfect for everyday cooking needs.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, white refrigerator, and white stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_VacantUpgradedKitchen01.jpg"
    },
    {
      "id": "ec_bc4fb63401d2449d4f775f28",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1bf5-35a7-749b-bd7a-5e2c7607be10.webp",
      "image_media": {
        "alt_text": "Kitchen area with light wood cabinets and white appliances",
        "public_id": "019d1bf5-35a7-749b-bd7a-5e2c7607be10",
        "storage_key": "property/6767906449166885/019d1bf5-35a7-749b-bd7a-5e2c7607be10.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring light wood cabinets, a double sink, dishwasher, and refrigerator. Ample counter space and overhead lighting.",
      "link": "false",
      "alt_text": "Kitchen area with light wood cabinets and white appliances",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_VacantUpgradedKitchen02.jpg"
    },
    {
      "id": "ec_647cc403c64ed5935e326994",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1bf5-3588-752a-829b-3870ceebb7d6.webp",
      "image_media": {
        "alt_text": "Interior view of a living room and kitchen area, with a glimpse of a bathroom.",
        "public_id": "019d1bf5-3588-752a-829b-3870ceebb7d6",
        "storage_key": "property/6767906449166885/019d1bf5-3588-752a-829b-3870ceebb7d6.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting, an open kitchen with ample cabinet space, and a visible bathroom. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "Interior view of a living room and kitchen area, with a glimpse of a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_VacantLivingRoom01.jpg"
    },
    {
      "id": "ec_dbd49009b9c3e02756ce1a4d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1bf5-35a6-742a-91b0-37d09078ec54.webp",
      "image_media": {
        "alt_text": "Spacious living room with sliding glass door to backyard",
        "public_id": "019d1bf5-35a6-742a-91b0-37d09078ec54",
        "storage_key": "property/6767906449166885/019d1bf5-35a6-742a-91b0-37d09078ec54.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "This is a spacious living room with plush carpeting and a sliding glass door that leads to a private backyard patio. The room is painted in neutral tones, creating a warm and inviting atmosphere.",
      "link": "false",
      "alt_text": "Spacious living room with sliding glass door to backyard",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_VacantLivingRoom02.jpg"
    },
    {
      "id": "ec_647a23de4f9126c08c9f4d24",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-916d-7509-989e-51ca62dd7d2f.webp",
      "image_media": {
        "alt_text": "Closet in a bedroom with a sliding door and a hallway visible through an open doorway.",
        "public_id": "019d1c25-916d-7509-989e-51ca62dd7d2f",
        "storage_key": "property/6767906449166885/019d1c25-916d-7509-989e-51ca62dd7d2f.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Explore the ample closet space in this bedroom, offering convenient storage solutions. The open doorway reveals a glimpse into the hallway.",
      "link": "false",
      "alt_text": "Closet in a bedroom with a sliding door and a hallway visible through an open doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_VacantBedroom01.jpg"
    },
    {
      "id": "ec_8a829bd8509281f2d9b2f0a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-916f-723c-8fb8-0f6223196d6b.webp",
      "image_media": {
        "alt_text": "Kitchen area with a refrigerator, stove, and cabinets.",
        "public_id": "019d1c25-916f-723c-8fb8-0f6223196d6b",
        "storage_key": "property/6767906449166885/019d1c25-916f-723c-8fb8-0f6223196d6b.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Compact kitchen featuring a refrigerator, stove, and ample cabinet space. The window provides natural light.",
      "link": "false",
      "alt_text": "Kitchen area with a refrigerator, stove, and cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_VacantKitchen01.jpg"
    },
    {
      "id": "ec_ff12685918571052b7a01770",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c00-9b1b-742c-a4fe-382f2ea0d76d.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, dishwasher, sink, and dark wood cabinets.",
        "public_id": "019d1c00-9b1b-742c-a4fe-382f2ea0d76d",
        "storage_key": "property/6767906449166885/019d1c00-9b1b-742c-a4fe-382f2ea0d76d.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "View of a kitchen featuring a white refrigerator, dishwasher, sink with chrome faucet, and dark wood cabinetry. A window overlooks the exterior of the building.",
      "link": "false",
      "alt_text": "Kitchen with white refrigerator, dishwasher, sink, and dark wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_VacantKitchen02.jpg"
    },
    {
      "id": "ec_607848cc79e4cfd6489af4b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c00-9b18-76fa-883c-78e439e4d0b4.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment unit showing a living area, a doorway, and a glimpse of the kitchen.",
        "public_id": "019d1c00-9b18-76fa-883c-78e439e4d0b4",
        "storage_key": "property/6767906449166885/019d1c00-9b18-76fa-883c-78e439e4d0b4.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Step into this inviting apartment unit, featuring a spacious living area that flows seamlessly into a functional kitchen. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "Interior view of an apartment unit showing a living area, a doorway, and a glimpse of the kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_VacantLivingRoom03.jpg"
    },
    {
      "id": "ec_95d39f318914d978dabd915d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-916b-77f8-8bb4-a1ba772ce993.webp",
      "image_media": {
        "alt_text": "Empty room with closet and open door to hallway.",
        "public_id": "019d1c25-916b-77f8-8bb4-a1ba772ce993",
        "storage_key": "property/6767906449166885/019d1c25-916b-77f8-8bb4-a1ba772ce993.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious empty room featuring a walk-in closet and a doorway leading to a hallway. Neutral carpet and white walls create a blank canvas for personalization.",
      "link": "false",
      "alt_text": "Empty room with closet and open door to hallway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_VacantBedroom02.jpg"
    },
    {
      "id": "ec_b943820c2d1f94be043a4483",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-916d-7509-989e-544bb4009d88.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, sink, and bathtub with shower.",
        "public_id": "019d1c25-916d-7509-989e-544bb4009d88",
        "storage_key": "property/6767906449166885/019d1c25-916d-7509-989e-544bb4009d88.webp",
        "width": 732,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, vanity with sink, and a bathtub with a shower, perfect for everyday use.",
      "link": "false",
      "alt_text": "Bathroom with toilet, sink, and bathtub with shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/GardenGlen_Portland_OR_VacantBathroom.jpg"
    },
    {
      "id": "ec_78bade1b541cf94dd78535da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c26-0cd9-737b-9234-204a002c681f.webp",
      "image_media": {
        "alt_text": "Cedar Lane Apartments sign and building exterior with parking lot",
        "public_id": "019d1c26-0cd9-737b-9234-204a002c681f",
        "storage_key": "property/6767906449166885/019d1c26-0cd9-737b-9234-204a002c681f.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Welcome to Cedar Lane Apartments, offering comfortable living with convenient access to local amenities. Our community features include ample parking and well-maintained grounds.",
      "link": "false",
      "alt_text": "Cedar Lane Apartments sign and building exterior with parking lot",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Cedar Lane Apartments Portland 2022-03.jpg"
    },
    {
      "id": "ec_a090eb6e01083b0cc26ed5da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c26-0c96-728d-9793-0ac2ba40daf7.webp",
      "image_media": {
        "alt_text": "Exterior view of a three-story apartment building with dark siding and a stone accent wall.",
        "public_id": "019d1c26-0c96-728d-9793-0ac2ba40daf7",
        "storage_key": "property/6767906449166885/019d1c26-0c96-728d-9793-0ac2ba40daf7.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Three-story apartment building featuring dark exterior siding, balconies, and a prominent stone accent wall. Parking lot in foreground.",
      "link": "false",
      "alt_text": "Exterior view of a three-story apartment building with dark siding and a stone accent wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Cedar Lane Apartments Portland  2022-02.jpg"
    },
    {
      "id": "ec_5bf8774f172e12862e921ba6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c26-0c98-737b-97e0-c4b17f7deccd.webp",
      "image_media": {
        "alt_text": "Apartment complex exterior with parking lot and cars.",
        "public_id": "019d1c26-0c98-737b-97e0-c4b17f7deccd",
        "storage_key": "property/6767906449166885/019d1c26-0c98-737b-97e0-c4b17f7deccd.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Exterior view of the apartment buildings showcasing the community's architecture and available parking.",
      "link": "false",
      "alt_text": "Apartment complex exterior with parking lot and cars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/Cedar Lane Apartments Portland  2022-01.jpg"
    },
    {
      "id": "ec_3b230f256615c25c691771b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-b39e-7609-bc05-4a8063f98897.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, a double sink, dishwasher, and white refrigerator.",
        "public_id": "019d1c25-b39e-7609-bc05-4a8063f98897",
        "storage_key": "property/6767906449166885/019d1c25-b39e-7609-bc05-4a8063f98897.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Discover a functional kitchen space featuring ample cabinet storage, a convenient double sink, dishwasher, and a full-sized refrigerator.",
      "link": "false",
      "alt_text": "Kitchen with dark wood cabinets, a double sink, dishwasher, and white refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CedarLane_Portland_OR_VacantUpgradedKitchen.jpg"
    },
    {
      "id": "ec_aa233d5f9afa07d8fde6faad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-b118-739f-9685-610002700fc9.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment showing a living area and kitchen.",
        "public_id": "019d1c25-b118-739f-9685-610002700fc9",
        "storage_key": "property/6767906449166885/019d1c25-b118-739f-9685-610002700fc9.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious apartment featuring a well-appointed kitchen and a comfortable living area with hardwood flooring and plush carpeting.",
      "link": "false",
      "alt_text": "Interior view of an apartment showing a living area and kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CedarLane_Portland_OR_VacantDiningRoom.jpg"
    },
    {
      "id": "ec_74716ee3aac81ecdb00c4d7e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-b013-7579-8556-71eacd2a9542.webp",
      "image_media": {
        "alt_text": "Living room adjacent to kitchen in apartment",
        "public_id": "019d1c25-b013-7579-8556-71eacd2a9542",
        "storage_key": "property/6767906449166885/019d1c25-b013-7579-8556-71eacd2a9542.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious living area with carpeted floors, adjacent to a functional kitchen with wooden cabinets and ample counter space.",
      "link": "false",
      "alt_text": "Living room adjacent to kitchen in apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CedarLane_Portland_OR_VacantLivingRoom02.jpg"
    },
    {
      "id": "ec_e12c9cc2f3a56969e091e5d9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-b0b6-75ca-92ca-aed05cde05c3.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment, showing a bathroom and kitchen area.",
        "public_id": "019d1c25-b0b6-75ca-92ca-aed05cde05c3",
        "storage_key": "property/6767906449166885/019d1c25-b0b6-75ca-92ca-aed05cde05c3.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Explore the interior of our apartments, featuring a well-appointed bathroom and a functional kitchen space.",
      "link": "false",
      "alt_text": "Interior view of an apartment, showing a bathroom and kitchen area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CedarLane_Portland_OR_VacantBedroom02.jpg"
    },
    {
      "id": "ec_0633cb199eea7281ec283893",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-b2ef-72a7-b3ee-f5ac7ef19d34.webp",
      "image_media": {
        "alt_text": "Kitchen with white refrigerator, oven, and sink.",
        "public_id": "019d1c25-b2ef-72a7-b3ee-f5ac7ef19d34",
        "storage_key": "property/6767906449166885/019d1c25-b2ef-72a7-b3ee-f5ac7ef19d34.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring a white refrigerator, oven, and sink, perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white refrigerator, oven, and sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CedarLane_Portland_OR_VacantKitchen.jpg"
    },
    {
      "id": "ec_ac20accb72239d41c8c38501",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c26-0bfe-7508-9b3e-e5467c251cfb.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment with carpeted floors, a large closet, and a door leading to a balcony.",
        "public_id": "019d1c26-0bfe-7508-9b3e-e5467c251cfb",
        "storage_key": "property/6767906449166885/019d1c26-0bfe-7508-9b3e-e5467c251cfb.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious apartment interior featuring a large closet, a private balcony accessible through a sliding glass door, and comfortable carpeted flooring.",
      "link": "false",
      "alt_text": "Interior view of an apartment with carpeted floors, a large closet, and a door leading to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CedarLane_Portland_OR_VacantLivingRoom01.jpg"
    },
    {
      "id": "ec_9335ac108f7b619cffabd671",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c26-0bfd-7538-bc8b-97c935dd2351.webp",
      "image_media": {
        "alt_text": "Empty bedroom with closet and hallway view.",
        "public_id": "019d1c26-0bfd-7538-bc8b-97c935dd2351",
        "storage_key": "property/6767906449166885/019d1c26-0bfd-7538-bc8b-97c935dd2351.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "This empty bedroom features a large closet with sliding doors and a view into the hallway.",
      "link": "false",
      "alt_text": "Empty bedroom with closet and hallway view.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CedarLane_Portland_OR_VacantBedroom01.jpg"
    },
    {
      "id": "ec_73c0ad5c74d3cd35557d8b8a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c25-916b-77f8-8bb4-a1ba772ce993.webp",
      "image_media": {
        "alt_text": "Empty room with closet and open door to hallway.",
        "public_id": "019d1c25-916b-77f8-8bb4-a1ba772ce993",
        "storage_key": "property/6767906449166885/019d1c25-916b-77f8-8bb4-a1ba772ce993.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious empty room featuring a walk-in closet and a doorway leading to a hallway. Neutral carpet and white walls create a blank canvas for personalization.",
      "link": "false",
      "alt_text": "Empty room with closet and open door to hallway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CedarLane_Portland_OR_VacantBedroom03.jpg"
    },
    {
      "id": "ec_c8576680df28674ad868011d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d1c26-0bf7-729e-ae53-ed802dab4f47.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers and dryers.",
        "public_id": "019d1c26-0bf7-729e-ae53-ed802dab4f47",
        "storage_key": "property/6767906449166885/019d1c26-0bf7-729e-ae53-ed802dab4f47.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "On-site laundry facilities make chores a breeze. Enjoy the convenience of washing and drying your clothes without leaving the property.",
      "link": "false",
      "alt_text": "Laundry room with multiple washers and dryers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CedarLane_Portland_OR_LaundryRoom.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_f824eb24-436e-4589-b7b3-fe489e2ad9b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Raising Cane’s Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "700 SW 5th Ave #1109, Portland, OR 97204, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "Diners say this fast food restaurant serves up delicious chicken fingers, Texas toast, and Cane's sauce, and they praise the friendly and efficient service. They also highlight the great value for the price, with many mentioning the chicken fingers are some of the best they've ever had.\n\nSome reviews mention the lines can be long, especially during peak hours.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-f0ed-749c-85fa-cb1fb0d13eb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f0ed-749c-85fa-cb1fb0d13eb6",
        "storage_key": "property/6767906449166885/019d08ab-f0ed-749c-85fa-cb1fb0d13eb6.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/or/portland/700-sw-5th-st-1109",
      "poi_directions_map_url": "https://maps.google.com/?cid=12547526630509412446&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "45.5175349",
      "poi_longitude": "-122.6778527",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-227-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-9b88-7332-972f-7924c7a060c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9b88-7332-972f-7924c7a060c0",
        "storage_key": "property/6767906449166885/019d08ab-9b88-7332-972f-7924c7a060c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR3PFivsLlVQRXoBEpf3EIa4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_cb9046ab-ddab-4770-abba-a050b07f7612",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Screen Door Pearl District",
      "poi_type": "Restaurants",
      "poi_address": "1131 NW Couch St, Portland, OR 97209, USA",
      "poi_short_description": "Well-lit, stylish destination with outdoor seating offering meals, beer, and cocktails.",
      "poi_long_description": "People say this Southern restaurant serves delicious chicken and waffles, cinnamon rolls, and Bananas Foster French Toast. They highlight the generous portions, flavorful dishes, and the quick service. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-f0de-7314-b0db-f18b949c08b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f0de-7314-b0db-f18b949c08b0",
        "storage_key": "property/6767906449166885/019d08ab-f0de-7314-b0db-f18b949c08b0.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "https://screendoorrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2574505151415432726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "screen-door-pearl-district",
      "poi_latitude": "45.523796",
      "poi_longitude": "-122.6827051",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-542-0882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-9b88-7332-972f-7924c7a060c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9b88-7332-972f-7924c7a060c0",
        "storage_key": "property/6767906449166885/019d08ab-9b88-7332-972f-7924c7a060c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLU7eCV0LlVQRFraHfst6uiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_86f09d1d-169c-41b4-9633-8da955f8af9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Luc Lac Vietnamese Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "835 SW 2nd Ave, Portland, OR 97204, USA",
      "poi_short_description": "Bustling counter-serve restaurant in a stylish setting serving pho, banh mi & other Vietnamese fare.",
      "poi_long_description": "People say this Vietnamese restaurant serves delicious coconut curry, vermicelli bowls, and pho. They highlight the vibrant and fun atmosphere, and the fast service. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-f126-718a-89bb-d0becb590ce6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f126-718a-89bb-d0becb590ce6",
        "storage_key": "property/6767906449166885/019d08ab-f126-718a-89bb-d0becb590ce6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.luclackitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11849354532108914595&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "luc-lac-vietnamese-kitchen",
      "poi_latitude": "45.5168971",
      "poi_longitude": "-122.6754165",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-222-0047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-9b88-7332-972f-7924c7a060c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9b88-7332-972f-7924c7a060c0",
        "storage_key": "property/6767906449166885/019d08ab-9b88-7332-972f-7924c7a060c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpTJKdg8KlVQRo08EmCpdcaQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_423f6075-60db-482c-960d-dc09c961f5e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Fogo de Chão Brazilian Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "930 SW 6th Ave, Portland, OR 97204, USA",
      "poi_short_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_long_description": "People say this Brazilian steakhouse offers a wide variety of meats, including picanha, filet mignon, and lamb, as well as a delicious salad bar with fresh vegetables, cheeses, and sides. They highlight the fun and lively atmosphere, and the attentive and friendly service. They also like the all-you-can-eat option and the reasonable prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-f119-735b-a822-bcfce3126e5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f119-735b-a822-bcfce3126e5f",
        "storage_key": "property/6767906449166885/019d08ab-f119-735b-a822-bcfce3126e5f.webp",
        "width": 1095,
        "height": 654
      },
      "poi_business_url": "https://fogodechao.com/brazil-cuts/?utm_source=sem&utm_medium=search&utm_campaign=evg&utm_id=lf-cnvrs&utm_term=brand&utm_content=bob&gclsrc=aw.ds&&utm_content=771480581692&mkwid=s&pcrid=771480581692&kw=fogo%20de%20chao&pmt=b&pdv=m&slid=&gad_source=1&gad_campaignid=22441774797&gbraid=0AAAAAok23aNqTgbAOwARMe3UpSaqRGEek&gclid=Cj0KCQjw9JLHBhC-ARIsAK4PhcrpT3UZzffs2tvvl9x7453QzsklEW_Gi4yv54fGDc2DhAY7XU30ETEaAjvMEALw_wcB",
      "poi_directions_map_url": "https://maps.google.com/?cid=17351528641511249354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "fogo-de-cho-brazilian-steakhouse",
      "poi_latitude": "45.517218",
      "poi_longitude": "-122.6793081",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-241-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-9b88-7332-972f-7924c7a060c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9b88-7332-972f-7924c7a060c0",
        "storage_key": "property/6767906449166885/019d08ab-9b88-7332-972f-7924c7a060c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMcKDSAUKlVQRylVL-10DzfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "custom_50bfa2ba-f12a-4be1-a2c8-eb6adf981600",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "9309 SW Washington Square Rd, Tigard, OR 97223, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "Diners say this restaurant offers a wide variety of dishes, including Bang Bang Chicken and Shrimp, cheesecake, and pasta, with many praising the extensive menu and delicious food. They also highlight the friendly and attentive service, and the vibrant and comfortable atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-0868-752a-945f-a88a2e9f6a28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-0868-752a-945f-a88a2e9f6a28",
        "storage_key": "property/6767906449166885/019d08ab-0868-752a-945f-a88a2e9f6a28.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/or/tigard-101.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=9275120421759837335&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "45.4510321",
      "poi_longitude": "-122.7823753",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-620-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-9b88-7332-972f-7924c7a060c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9b88-7332-972f-7924c7a060c0",
        "storage_key": "property/6767906449166885/019d08ab-9b88-7332-972f-7924c7a060c0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6omzVcMlVQRl2T3w-HYt4A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1417a462-e75b-45d7-90c6-a77f67a248d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Washington Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "9585 SW Washington Square Rd, Portland, OR 97223, USA",
      "poi_short_description": "Large shopping center with a variety of department stores, specialty shops & food options.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and services, including a Cheesecake Factory, a Lego store, and a variety of clothing stores. They also highlight the clean and well-maintained environment, the friendly and helpful staff, and the convenient parking.\n\nOther reviews mention the food court can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-7acc-73ee-95ba-f2bd30c6c0d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-7acc-73ee-95ba-f2bd30c6c0d0",
        "storage_key": "property/6767906449166885/019d08ab-7acc-73ee-95ba-f2bd30c6c0d0.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.shopwashingtonsquare.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=8036230870585529003&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "washington-square",
      "poi_latitude": "45.4502491",
      "poi_longitude": "-122.7812183",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-639-8860",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-9b8c-71ca-b00d-af81afc35cf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9b8c-71ca-b00d-af81afc35cf2",
        "storage_key": "property/6767906449166885/019d08ab-9b8c-71ca-b00d-af81afc35cf2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJy9M2zVcMlVQRq1JHJmZthm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ed2f40b1-36bf-4054-b7e2-86c40e828a1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Powell's City of Books",
      "poi_type": "Shopping & Retail",
      "poi_address": "1005 W Burnside St, Portland, OR 97209, USA",
      "poi_short_description": "Iconic bookseller offering a diverse selection of used & new volumes, plus gifts for bibliophiles.",
      "poi_long_description": "People say this bookstore offers a vast selection of new and used books, including a rare book room, and a variety of genres. They highlight the well-organized layout, the helpful staff, and the fun, immersive atmosphere. They also like the staff recommendations and the in-store cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-fb24-74cf-a81b-e1f404b8eb9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-fb24-74cf-a81b-e1f404b8eb9e",
        "storage_key": "property/6767906449166885/019d08ab-fb24-74cf-a81b-e1f404b8eb9e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.powells.com/locations/powells-city-of-books",
      "poi_directions_map_url": "https://maps.google.com/?cid=6978470595407941935&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "powells-city-of-books",
      "poi_latitude": "45.5232451",
      "poi_longitude": "-122.6814329",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 800-878-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-9b8c-71ca-b00d-af81afc35cf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9b8c-71ca-b00d-af81afc35cf2",
        "storage_key": "property/6767906449166885/019d08ab-9b8c-71ca-b00d-af81afc35cf2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJByq0twMKlVQRL5HMcgiC2GA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_c2f10d15-7d84-4e6b-8e21-b503380c8ac6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Uwajimaya Beaverton",
      "poi_type": "Shopping & Retail",
      "poi_address": "10500 SW Beaverton Hillsdale Hwy, Beaverton, OR 97005, USA",
      "poi_short_description": "Perennial Asian grocery stocking meats, produce & prepared foods, plus gifts & home goods.",
      "poi_long_description": "People say this Asian grocery store offers a wide selection of fresh seafood, produce, and Japanese groceries, including musubi, onigiri, and poke. They highlight the friendly and helpful staff, and the fun, unique shopping experience. They also like the bookstore in the back and the delicious hot food options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-fb13-70b0-a9d6-3f55c79ca8a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-fb13-70b0-a9d6-3f55c79ca8a2",
        "storage_key": "property/6767906449166885/019d08ab-fb13-70b0-a9d6-3f55c79ca8a2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.uwajimaya.com/visit/beaverton/?utm_source=localprofiles&utm_medium=organic&utm_content=beaverton&utm_campaign=fm",
      "poi_directions_map_url": "https://maps.google.com/?cid=6570527899701517362&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "uwajimaya-beaverton",
      "poi_latitude": "45.48564529999999",
      "poi_longitude": "-122.7849074",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-643-4512",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-9b93-71a9-9d69-17768c5ddc2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9b93-71a9-9d69-17768c5ddc2f",
        "storage_key": "property/6767906449166885/019d08ab-9b93-71a9-9d69-17768c5ddc2f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiVB9wAQMlVQRMpyACFA0L1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_88408174-32b3-4750-9169-53d69dbdd27b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Bridgeport Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "7455 SW Bridgeport Rd, Tigard, OR 97224, USA",
      "poi_short_description": "Outdoor shopping complex featuring entertainment, high-end retailers & sit-down & casual dining.",
      "poi_long_description": "People say this shopping center offers a wide selection of shops, restaurants, and a movie theater. They also highlight the clean, beautiful, and open-air atmosphere, as well as the friendly staff.\n\nOther reviews mention the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-fd9e-726e-8282-cbfb1967ba0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-fd9e-726e-8282-cbfb1967ba0c",
        "storage_key": "property/6767906449166885/019d08ab-fd9e-726e-8282-cbfb1967ba0c.webp",
        "width": 1280,
        "height": 484
      },
      "poi_business_url": "https://www.bridgeport-village.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2515733834919836986&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bridgeport-village",
      "poi_latitude": "45.3957237",
      "poi_longitude": "-122.7528244",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-968-1704",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-9b8c-71ca-b00d-af81afc35cf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9b8c-71ca-b00d-af81afc35cf2",
        "storage_key": "property/6767906449166885/019d08ab-9b8c-71ca-b00d-af81afc35cf2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnYnrbetylVQROv3TC5iu6SI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1841fee5-274a-4f9f-8b27-4549fa788926",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Pioneer Place",
      "poi_type": "Shopping & Retail",
      "poi_address": "700 SW 5th Ave, Portland, OR 97204, USA",
      "poi_short_description": "Chain known for unique gadgets, gifts & lifestyle items, such as electronics & travel accessories.",
      "poi_long_description": "People say this shopping center is clean and safe, with a high-end selection of stores and a convenient location near hotels. They also highlight the efficient service and well-maintained facilities, including restrooms and escalators.\n\nSome reviews mention the dining options can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-fdcc-7734-82fb-b477424edd87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-fdcc-7734-82fb-b477424edd87",
        "storage_key": "property/6767906449166885/019d08ab-fdcc-7734-82fb-b477424edd87.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pioneerplace.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4077299775746900834&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-place",
      "poi_latitude": "45.5183547",
      "poi_longitude": "-122.6773",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-228-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-9b8c-71ca-b00d-af81afc35cf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-9b8c-71ca-b00d-af81afc35cf2",
        "storage_key": "property/6767906449166885/019d08ab-9b8c-71ca-b00d-af81afc35cf2.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH4wFbwUKlVQRYoMsKIt6lTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_380172a8-41b2-450e-8081-fa9733bbdf25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Lewis & Clark College",
      "poi_type": "Education",
      "poi_address": "615 S Palatine Hill Rd, Portland, OR 97219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-938b-74d8-823b-3a4be57a6aa2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-938b-74d8-823b-3a4be57a6aa2",
        "storage_key": "property/6767906449166885/019d08ab-938b-74d8-823b-3a4be57a6aa2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lclark.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4013463715069943394&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lewis--clark-college",
      "poi_latitude": "45.450223",
      "poi_longitude": "-122.670186",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-768-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a14c-713d-92e5-61db0956fa0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a14c-713d-92e5-61db0956fa0f",
        "storage_key": "property/6767906449166885/019d08ab-a14c-713d-92e5-61db0956fa0f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfSSk0DMLlVQRYt6pD_yvsjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_714f5294-fab5-4abe-b6bf-8edddb1e98f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Portland Community College Sylvania",
      "poi_type": "Education",
      "poi_address": "12000 SW 49th Ave, Portland, OR 97219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-41de-71fe-b303-0dfa8ee622c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-41de-71fe-b303-0dfa8ee622c2",
        "storage_key": "property/6767906449166885/019d08ab-41de-71fe-b303-0dfa8ee622c2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pcc.edu/about/locations/sylvania/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6662908794779881992&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-community-college-sylvania",
      "poi_latitude": "45.4377659",
      "poi_longitude": "-122.7307089",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 971-722-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a14c-713d-92e5-61db0956fa0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a14c-713d-92e5-61db0956fa0f",
        "storage_key": "property/6767906449166885/019d08ab-a14c-713d-92e5-61db0956fa0f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUfp1OLoMlVQRCFKuSz9od1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f96a09e8-cac2-4536-ace7-58d9c21a4892",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Portland State University",
      "poi_type": "Education",
      "poi_address": "1825 SW Broadway, Portland, OR 97201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-0406-752a-ad7e-8824f0bcb9ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0406-752a-ad7e-8824f0bcb9ba",
        "storage_key": "property/6767906449166885/019d08ac-0406-752a-ad7e-8824f0bcb9ba.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.pdx.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3895283153264588693&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-state-university",
      "poi_latitude": "45.5111153",
      "poi_longitude": "-122.6833385",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a14c-713d-92e5-61db0956fa0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a14c-713d-92e5-61db0956fa0f",
        "storage_key": "property/6767906449166885/019d08ab-a14c-713d-92e5-61db0956fa0f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkbAL-LGglVQRlTfmyWPTDjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bb1f4d06-7258-426d-acb2-1c27749f89ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Beaverton City Library",
      "poi_type": "Education",
      "poi_address": "12375 SW 5th St, Beaverton, OR 97005, USA",
      "poi_short_description": "Multistory library with kids' areas, computers and board game rentals.",
      "poi_long_description": "People say this public library offers a wide selection of books, music CDs, DVDs/Blu-rays, and video games, as well as digital resources and a \"Library of Things.\" They highlight the spacious layout, beautiful architecture, and numerous working, studying, and reading spaces, including a dedicated children's area with storytime rooms. They also like the friendly and helpful staff, and the various activities and events for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-04e9-767a-8792-053f7e2eb947.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-04e9-767a-8792-053f7e2eb947",
        "storage_key": "property/6767906449166885/019d08ac-04e9-767a-8792-053f7e2eb947.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://beavertonlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2456838086164544331&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-city-library",
      "poi_latitude": "45.4840984",
      "poi_longitude": "-122.804071",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-644-2197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a14c-713d-92e5-61db0956fa0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a14c-713d-92e5-61db0956fa0f",
        "storage_key": "property/6767906449166885/019d08ab-a14c-713d-92e5-61db0956fa0f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv_YnSyAMlVQRS_t89DhxGCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_f212949f-c32e-48c6-b6c6-5f5220f76600",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Reed College",
      "poi_type": "Education",
      "poi_address": "3203 SE Woodstock Blvd, Portland, OR 97202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-04e9-767a-8792-0283cd6ab492.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-04e9-767a-8792-0283cd6ab492",
        "storage_key": "property/6767906449166885/019d08ac-04e9-767a-8792-0283cd6ab492.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.reed.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5108961514061207608&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reed-college",
      "poi_latitude": "45.4810848",
      "poi_longitude": "-122.6308086",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 503-771-1112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a14c-713d-92e5-61db0956fa0f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a14c-713d-92e5-61db0956fa0f",
        "storage_key": "property/6767906449166885/019d08ab-a14c-713d-92e5-61db0956fa0f.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcwb3mKIKlVQROJjCuG2t5kY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a57fa78f-ca89-476c-906f-29e1494718eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Oregon Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4001 SW Canyon Rd, Portland, OR 97221, USA",
      "poi_short_description": "64-acre zoo featuring elephants, polar bears & other animal exhibits emphasizing conservation.",
      "poi_long_description": "People say this zoo offers a wide variety of animals, including elephants, polar bears, giraffes, and lions, and features a popular baby elephant. They highlight the well-maintained exhibits, the spacious and natural habitats, and the fun train ride. They also like the family-friendly atmosphere and the knowledgeable staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-04e5-73cd-a724-62f5602e65b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-04e5-73cd-a724-62f5602e65b9",
        "storage_key": "property/6767906449166885/019d08ac-04e5-73cd-a724-62f5602e65b9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.oregonzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16710360885333195814&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oregon-zoo",
      "poi_latitude": "45.5093572",
      "poi_longitude": "-122.714291",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-226-1561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBbhWuC4KlVQRJvzdnrAg5-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_77b66725-1ea6-4470-9a39-2e88892a71f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "OMSI",
      "poi_type": "Entertainment",
      "poi_address": "1945 SE Water Ave, Portland, OR 97214, USA",
      "poi_short_description": "Rotating shows, science labs, submarine tours & planetarium at a museum with monthly 21+ events.",
      "poi_long_description": "People say this museum offers a wide variety of interactive exhibits, including a dinosaur exhibit, a submarine tour, and a planetarium. They highlight the educational and family-friendly atmosphere, and the rotating exhibits that keep the experience fresh. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-0bca-7770-970e-ab0e8b4139d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0bca-7770-970e-ab0e8b4139d1",
        "storage_key": "property/6767906449166885/019d08ac-0bca-7770-970e-ab0e8b4139d1.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://omsi.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15020746415816767564&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "omsi",
      "poi_latitude": "45.5083931",
      "poi_longitude": "-122.6660355",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-797-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a150-74ab-98aa-d5d687a93324.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a150-74ab-98aa-d5d687a93324",
        "storage_key": "property/6767906449166885/019d08ab-a150-74ab-98aa-d5d687a93324.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RKx6HIKlVQRTPj6J0hpdNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_707bb31c-cd52-434b-b451-0f6fddcff4df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Providence Park",
      "poi_type": "Entertainment",
      "poi_address": "1844 SW Morrison St, Portland, OR 97205, USA",
      "poi_short_description": "Sports & events venue with stadium & field hosting Major League Soccer, college football & more.",
      "poi_long_description": "Fans say this stadium offers an exciting atmosphere for soccer games and concerts, with a great selection of food and drinks, including local beers. They also highlight the friendly and helpful staff, and the clean and well-maintained facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-0c38-7417-8003-1be596988543.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0c38-7417-8003-1be596988543",
        "storage_key": "property/6767906449166885/019d08ac-0c38-7417-8003-1be596988543.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.timbers.com/providencepark?utm_source=Google%20Maps%20-%20Locl.io&utm_medium=Website%20Button&utm_campaign=Google%20Maps_Locl.io2019",
      "poi_directions_map_url": "https://maps.google.com/?cid=18429963036675327438&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "providence-park",
      "poi_latitude": "45.521532",
      "poi_longitude": "-122.6917971",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-553-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-4750-700e-a361-b2a4e306ef56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-4750-700e-a361-b2a4e306ef56",
        "storage_key": "property/6767906449166885/019d08ac-4750-700e-a361-b2a4e306ef56.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2SA5mB0KlVQRzsWcWLxhxP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_d179d3aa-77e1-4d4d-8796-5a39591c0d66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Pittock Mansion",
      "poi_type": "Entertainment",
      "poi_address": "3229 NW Pittock Dr, Portland, OR 97210, USA",
      "poi_short_description": "23-room mansion from 1914 now a museum, featuring gardens, period furnishings & scenic views.",
      "poi_long_description": "People say this local history museum offers breathtaking views of the city and Mount Hood, and features a historic mansion with period furniture and decor. They highlight the beautifully maintained grounds, gardens, and hiking trails, and the informative self-guided tour. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-0e12-7159-a03d-ff26e1c2a565.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0e12-7159-a03d-ff26e1c2a565",
        "storage_key": "property/6767906449166885/019d08ac-0e12-7159-a03d-ff26e1c2a565.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://pittockmansion.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13828917755801354490&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pittock-mansion",
      "poi_latitude": "45.5252061",
      "poi_longitude": "-122.7162689",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-823-3623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a150-74ab-98aa-d5d687a93324.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a150-74ab-98aa-d5d687a93324",
        "storage_key": "property/6767906449166885/019d08ab-a150-74ab-98aa-d5d687a93324.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJU2_QC5IJlVQR-sChHm4v6r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_169edfd1-1253-4dbc-89ea-32aa0a3c582c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Oaks Amusement Park",
      "poi_type": "Entertainment",
      "poi_address": "7805 SE Oaks Park Way, Portland, OR 97202, USA",
      "poi_short_description": "Family-oriented, circa-1905 amusement park offering wooden skating rink, mini-golf & picnic grounds.",
      "poi_long_description": "People say this amusement park offers a variety of rides, including a roller coaster, bumper cars, and go-karts, as well as a skating rink, arcade, and carnival games. They also highlight the fun atmosphere, the fast-moving lines, and the friendly staff.\n\nOther reviews mention it can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-4c47-72d8-9e5e-4c9cc09cec9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-4c47-72d8-9e5e-4c9cc09cec9e",
        "storage_key": "property/6767906449166885/019d08ab-4c47-72d8-9e5e-4c9cc09cec9e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://oakspark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11424693522040311580&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oaks-amusement-park",
      "poi_latitude": "45.472652",
      "poi_longitude": "-122.6613775",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-233-5777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWaUbrOcKlVQRHE_rSDqqjJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_5602e870-0437-438f-8d64-182527801d3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "600 SW 116th Ave, Portland, OR 97225, USA",
      "poi_short_description": "Athletic country club chain in Cedar Mill with a gym, an outdoor beach club, pools, basketball and pickleball courts, and a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of classes, top-notch equipment, and multiple pools, including an adults-only option, and provides convenient amenities like a cafe, lounge, and clean locker rooms with saunas and plunge pools.\n\nOther reviews mention the price can be high and the parking can be difficult.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-0f6d-70f9-9159-a65d17da5d31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0f6d-70f9-9159-a65d17da5d31",
        "storage_key": "property/6767906449166885/019d08ac-0f6d-70f9-9159-a65d17da5d31.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/or/beaverton.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=8291423413939196135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "45.5153662",
      "poi_longitude": "-122.7940413",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-616-9950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ88xwwvQJlVQR59AzRqoNEXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ac324d8e-314a-4775-904d-831f464498f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "DoveLewis 24/7 Veterinary Emergency Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1945 NW Pettygrove St, Portland, OR 97209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-13b2-7234-b274-85de80e8cc47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-13b2-7234-b274-85de80e8cc47",
        "storage_key": "property/6767906449166885/019d08ac-13b2-7234-b274-85de80e8cc47.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://dovelewis.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2726875662202026056&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dovelewis-247-veterinary-emergency-hospital",
      "poi_latitude": "45.5330605",
      "poi_longitude": "-122.6913345",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-228-7281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC24DqfwJlVQRSLg1mPfO1yU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_8b8ce2f1-bf17-45cb-a12b-82e718db0248",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Villa Sport Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "13900 SW Meridian St, Beaverton, OR 97005, USA",
      "poi_short_description": "Large, resort-like, family-oriented recreation center featuring a gym, plus numerous clean pools (indoors and out), a hot tub and a sauna.",
      "poi_long_description": "People say this gym offers a variety of pools, fitness classes, and amenities, including a steam room, sauna, and hot tubs. They also highlight the family-friendly vibe, the dedicated instructors, and the welcoming staff.\n\nOther reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-1790-72eb-8e12-357aa73ac6c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-1790-72eb-8e12-357aa73ac6c5",
        "storage_key": "property/6767906449166885/019d08ac-1790-72eb-8e12-357aa73ac6c5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.villasport.com/beaverton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6712726625660967216&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "villa-sport-athletic-club",
      "poi_latitude": "45.5039949",
      "poi_longitude": "-122.8247248",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 971-317-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaSSIqMEOlVQRMBnU7ExlKF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_5a01c00a-32b6-48ce-b89d-64f6b8f54275",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8235 SW Apple Way, Portland, OR 97225, USA",
      "poi_short_description": "Large fitness center featuring ample cardio machines, tanning beds and hydro-massage loungers, plus clean showers.",
      "poi_long_description": "People say this gym offers a wide selection of equipment, including hack squat, vertical leg press, and four Smith machines, and most lockers already have locks. They highlight the spacious layout, clean facilities, and the availability of machines even during peak hours. They also like the friendly, helpful, and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-5937-70af-901b-ee5908084de3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-5937-70af-901b-ee5908084de3",
        "storage_key": "property/6767906449166885/019d08ab-5937-70af-901b-ee5908084de3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/portland-raleigh-hills-or?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=2165421477037240221&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "45.4859322",
      "poi_longitude": "-122.7625921",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-477-4107",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwYVFIqgLlVQRnW_OR1wfDR4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_92e355d1-e0d3-4983-8b1d-93e97c9522d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "17942 SW McEwan Rd, Tigard, OR 97224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-1cf3-762a-93b2-a6653b1668fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-1cf3-762a-93b2-a6653b1668fb",
        "storage_key": "property/6767906449166885/019d08ac-1cf3-762a-93b2-a6653b1668fb.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/tigard-or/tualatin-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=709569765366759855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "45.3942716",
      "poi_longitude": "-122.7437279",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-670-0400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0jwLe9ylVQRrwELMPHl2Ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b00df2d4-7f01-4fe4-bb58-1ceb4bdd21d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7405 SW Nyberg St, Tualatin, OR 97062, USA",
      "poi_short_description": "Chain, clean gym featuring free weights, sports facilities and friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of weights, cardio equipment, and classes, as well as a basketball court, hot tub, sauna, and pool. They also highlight the clean facilities, including the locker rooms and sauna, and the friendly and helpful staff.\n\nOther reviews mention the Wi-Fi can be unreliable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-1d86-715b-b83a-374aaa875057.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-1d86-715b-b83a-374aaa875057",
        "storage_key": "property/6767906449166885/019d08ac-1d86-715b-b83a-374aaa875057.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=1097&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14650673231861924082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "45.385637",
      "poi_longitude": "-122.752729",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-404-0126",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyqRr41ylVQR8kB0ia6lUcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_620bf29c-12eb-4d4a-8b85-3dd697095e20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "OHSU Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3181 SW Sam Jackson Park Rd, Portland, OR 97239, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-2483-736a-b4c0-aef33629952f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2483-736a-b4c0-aef33629952f",
        "storage_key": "property/6767906449166885/019d08ac-2483-736a-b4c0-aef33629952f.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.ohsu.edu/visit/ohsu-hospital-portland?utm_source=gmb&utm_medium=organic&utm_content=LocationHospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=15363967688716245467&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ohsu-hospital",
      "poi_latitude": "45.4992756",
      "poi_longitude": "-122.684882",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-494-8311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a6be-74db-ba9e-2ee04196a5fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a6be-74db-ba9e-2ee04196a5fa",
        "storage_key": "property/6767906449166885/019d08ab-a6be-74db-ba9e-2ee04196a5fa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ766_OkQKlVQR29mCCjbHN9U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b2f1a869-2929-47a0-a653-3fbc819a0e3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Providence St. Vincent Hospital East Pavilion",
      "poi_type": "Health and Wellness",
      "poi_address": "9155 SW Barnes Rd, Portland, OR 97225, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-23b6-73f8-8bfe-2d17234116e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-23b6-73f8-8bfe-2d17234116e8",
        "storage_key": "property/6767906449166885/019d08ac-23b6-73f8-8bfe-2d17234116e8.webp",
        "width": 1280,
        "height": 815
      },
      "poi_business_url": "https://oregon.providence.org/location-directory/p/providence-st-vincent-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5100053104868075598&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "providence-st-vincent-hospital-east-pavilion",
      "poi_latitude": "45.510411",
      "poi_longitude": "-122.7701193",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-216-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a6be-74db-ba9e-2ee04196a5fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a6be-74db-ba9e-2ee04196a5fa",
        "storage_key": "property/6767906449166885/019d08ab-a6be-74db-ba9e-2ee04196a5fa.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJtQXvYkMJlVQRTihKE0cHx0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6cb176b5-0d4c-403f-83a7-a3e1e41f104a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Portland Japanese Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "611 SW Kingston Ave, Portland, OR 97205, USA",
      "poi_short_description": "Many styles of gardens showcased in serene 5.5-acre space with waterfall, teahouse & mountain view.",
      "poi_long_description": "People say this garden offers stunning scenery, beautiful bonsai, and a peaceful atmosphere. They highlight the relaxing and serene vibe, and the well-maintained grounds with water features, koi ponds, and a waterfall. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-2639-705e-b143-24171be4e101.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2639-705e-b143-24171be4e101",
        "storage_key": "property/6767906449166885/019d08ac-2639-705e-b143-24171be4e101.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://japanesegarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11424717693547273965&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-japanese-garden",
      "poi_latitude": "45.5188634",
      "poi_longitude": "-122.7080354",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-223-1321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a6be-74db-ba9e-32ae15ff6a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a6be-74db-ba9e-32ae15ff6a59",
        "storage_key": "property/6767906449166885/019d08ab-a6be-74db-ba9e-32ae15ff6a59.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJecbtFYoJlVQR7V4BJzbAjJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_4123c90a-46df-4fbf-b773-e6668cc2e7e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "International Rose Test Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 SW Kingston Ave, Portland, OR 97205, USA",
      "poi_short_description": "City-maintained rose test gardens founded in 1917, featuring 10,000+ plants in manicured displays.",
      "poi_long_description": "People say this garden offers a stunning variety of roses, with vibrant colors and intoxicating fragrances. They highlight the peaceful and serene atmosphere, and the beautiful views of the city and mountains. They also like the free admission and the availability of a free shuttle. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-6d0c-732a-860a-282836bdc835.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6d0c-732a-860a-282836bdc835",
        "storage_key": "property/6767906449166885/019d08ab-6d0c-732a-860a-282836bdc835.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portland.gov/parks/washington-park-international-rose-test-garden",
      "poi_directions_map_url": "https://maps.google.com/?cid=10519281268788551622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "international-rose-test-garden",
      "poi_latitude": "45.5189524",
      "poi_longitude": "-122.7052686",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 503-823-3636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a6be-74db-ba9e-32ae15ff6a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a6be-74db-ba9e-32ae15ff6a59",
        "storage_key": "property/6767906449166885/019d08ab-a6be-74db-ba9e-32ae15ff6a59.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJfarJiIoJlVQRxt-PlpT--5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_7e435ea9-bcbc-46d9-be4a-a9fd9ac3e04c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Pioneer Courthouse Square",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "701 SW 6th Ave, Portland, OR 97204, USA",
      "poi_short_description": "Called the city's \"living room,\" this plaza is set beside an 1875 courthouse & hosts regular events.",
      "poi_long_description": "People say this city park offers a variety of events, festivals, and live music, and is a great place for people watching and relaxing. They also highlight the fun, lively atmosphere, and the convenient access to food carts, coffee shops, and public transportation.\n\nOther reviews mention the crowd can be large.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-4aa5-7099-aad2-1095f6156e11.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-4aa5-7099-aad2-1095f6156e11",
        "storage_key": "property/6767906449166885/019d08ab-4aa5-7099-aad2-1095f6156e11.webp",
        "width": 640,
        "height": 426
      },
      "poi_business_url": "http://thesquarepdx.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18355606501016238535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-courthouse-square",
      "poi_latitude": "45.5188944",
      "poi_longitude": "-122.6793265",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-223-1613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a6be-74db-ba9e-32ae15ff6a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a6be-74db-ba9e-32ae15ff6a59",
        "storage_key": "property/6767906449166885/019d08ab-a6be-74db-ba9e-32ae15ff6a59.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEz5wHQUKlVQRx3nsSdw2vP4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4b629a30-8625-431a-8bfa-eaaa809a3909",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Hoyt Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4000 SW Fairview Blvd, Portland, OR 97221, USA",
      "poi_short_description": "190-acre park with thousands of native, global & endangered trees, plus 12 miles of hiking trails.",
      "poi_long_description": "People say this arboretum offers a wide variety of trees and plants, including redwoods, and well-maintained trails for hiking. They highlight the peaceful and beautiful atmosphere, and the clearly labeled paths. They also like the helpful staff and the convenient amenities, such as restrooms, a gift shop, and a free shuttle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-6a6f-7097-9a8d-1dce3ca064ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-6a6f-7097-9a8d-1dce3ca064ac",
        "storage_key": "property/6767906449166885/019d08ab-6a6f-7097-9a8d-1dce3ca064ac.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.hoytarboretum.org/?utm_source=google-gmb-maps&utm_medium=gmb-website-button&utm_campaign=locl.io&utm_content=c38e859c-b096-4ae9-b3a9-551f21ba189e",
      "poi_directions_map_url": "https://maps.google.com/?cid=132726812224680572&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hoyt-arboretum",
      "poi_latitude": "45.5162616",
      "poi_longitude": "-122.7152124",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-865-8733",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a6be-74db-ba9e-32ae15ff6a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a6be-74db-ba9e-32ae15ff6a59",
        "storage_key": "property/6767906449166885/019d08ab-a6be-74db-ba9e-32ae15ff6a59.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8cJu-ocJlVQRfHLSHlWK1wE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_9394bc85-8432-44b2-9af7-f794aea9cd8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Tom McCall Waterfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "98 SW Naito Pkwy, Portland, OR 97204, USA",
      "poi_short_description": "Riverfront green belt featuring public art, historical monuments, paved paths & a fountain.",
      "poi_long_description": "People say this city park offers beautiful scenery, including cherry blossoms, a river, and fountains. They highlight the park is a great place for walking, enjoying the riverfront, and attending festivals and events. They also like the park's chill and relaxing vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-2ec2-7209-aa62-a5cff408c92f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2ec2-7209-aa62-a5cff408c92f",
        "storage_key": "property/6767906449166885/019d08ac-2ec2-7209-aa62-a5cff408c92f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.portlandoregon.gov/parks/finder/index.cfm?action=viewpark&propertyid=156",
      "poi_directions_map_url": "https://maps.google.com/?cid=18239819029682334719&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tom-mccall-waterfront-park",
      "poi_latitude": "45.5227536",
      "poi_longitude": "-122.6699971",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-823-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a6be-74db-ba9e-32ae15ff6a59.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a6be-74db-ba9e-32ae15ff6a59",
        "storage_key": "property/6767906449166885/019d08ab-a6be-74db-ba9e-32ae15ff6a59.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQ2FZAcKlVQR_yugz8TaIP0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_59cea8f1-ef56-40a2-aa67-9c28877b89b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Portland Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "800 NW 6th Ave, Portland, OR 97209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-2f49-75b8-a295-d47faf710754.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2f49-75b8-a295-d47faf710754",
        "storage_key": "property/6767906449166885/019d08ac-2f49-75b8-a295-d47faf710754.webp",
        "width": 914,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=PDX",
      "poi_directions_map_url": "https://maps.google.com/?cid=16883121867529895098&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "portland-union-station",
      "poi_latitude": "45.5290829",
      "poi_longitude": "-122.6767744",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-48f8-7369-a387-93dafa5c3fbc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-48f8-7369-a387-93dafa5c3fbc",
        "storage_key": "property/6767906449166885/019d08ac-48f8-7369-a387-93dafa5c3fbc.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1YQlXlWnlVQRury_TePlTOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_36a650c1-5a71-47b8-89d7-f8d98b59ce12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Beaverton TC MAX Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-7996-73bf-961b-64ab317935fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-7996-73bf-961b-64ab317935fe",
        "storage_key": "property/6767906449166885/019d08ab-7996-73bf-961b-64ab317935fe.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?id=9821",
      "poi_directions_map_url": "https://maps.google.com/?cid=13913915888813031590&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "beaverton-tc-max-station",
      "poi_latitude": "45.4914575",
      "poi_longitude": "-122.8016546",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJnQ7Mt6YOlVQRpkBdI8goGME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_e674dc31-c2bc-4d2c-948b-cf9db5b7a6f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Millikan Way",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97005, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-30db-728e-8c9c-17f11560d13f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-30db-728e-8c9c-17f11560d13f",
        "storage_key": "property/6767906449166885/019d08ac-30db-728e-8c9c-17f11560d13f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://trimet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14285898637418825828&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "millikan-way",
      "poi_latitude": "45.49523019999999",
      "poi_longitude": "-122.8216184",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0Zr7ZYOlVQRZAiW7B61QcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_7102a9a7-22c0-4ca3-8c3a-91637c577419",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Elmonica/SW 170th Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-31f6-75dc-a1b3-59451ba7205a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-31f6-75dc-a1b3-59451ba7205a",
        "storage_key": "property/6767906449166885/019d08ac-31f6-75dc-a1b3-59451ba7205a.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?id=9829",
      "poi_directions_map_url": "https://maps.google.com/?cid=12242366764481047543&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elmonicasw-170th-ave",
      "poi_latitude": "45.5099231",
      "poi_longitude": "-122.8515139",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-c6QOOMOlVQR9-vwnrWf5ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_68725ab2-2344-46a1-8a4c-494c052b7854",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "PSU Urban Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Portland, OR 97201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-38bb-70f0-8beb-8b3edc070c38.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-38bb-70f0-8beb-8b3edc070c38",
        "storage_key": "property/6767906449166885/019d08ac-38bb-70f0-8beb-8b3edc070c38.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "http://trimet.org/#tracker/stop/10764",
      "poi_directions_map_url": "https://maps.google.com/?cid=834252715071957722&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "psu-urban-center",
      "poi_latitude": "45.51222",
      "poi_longitude": "-122.682078",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH_XoLxEKlVQR2urEnmzckws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_eb422624-436b-4aa1-97b4-f915278ffbb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Nike World Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Bowerman Dr, Beaverton, OR 97005, USA",
      "poi_short_description": "Chain retailer selling a range of Nike athletic footwear, apparel & accessories for adults & kids.",
      "poi_long_description": "Chain retailer selling a range of Nike athletic footwear, apparel & accessories for adults & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-824b-779b-b716-cd4de8c77983.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-824b-779b-b716-cd4de8c77983",
        "storage_key": "property/6767906449166885/019d08ab-824b-779b-b716-cd4de8c77983.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://about.nike.com/pages/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=12026902182619501264&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nike-world-headquarters",
      "poi_latitude": "45.5075349",
      "poi_longitude": "-122.8272752",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-671-6453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbaRNTcIOlVQR0NJnV9Aj6KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d06aefea-d61c-460a-93a7-5b4a3f558ff7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Lam Research",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11355 SW Leveton Dr, Tualatin, OR 97062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-3a27-70da-83bb-98c184f01d10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-3a27-70da-83bb-98c184f01d10",
        "storage_key": "property/6767906449166885/019d08ac-3a27-70da-83bb-98c184f01d10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lamresearch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8683645162624889977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lam-research",
      "poi_latitude": "45.38651220000001",
      "poi_longitude": "-122.7923427",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 503-685-8345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU_cRBl5tlVQRebTLeUSBgng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5444a181-f073-43b4-970e-7dd31f1d3630",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Nike - Lebron James",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15050 SW Koll Pkwy, Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-3b58-71ae-a8c4-9b8356c87c25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-3b58-71ae-a8c4-9b8356c87c25",
        "storage_key": "property/6767906449166885/019d08ac-3b58-71ae-a8c4-9b8356c87c25.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://lebronjamesinnovationcenter.nike.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15961945776638885973&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nike---lebron-james",
      "poi_latitude": "45.51239169999999",
      "poi_longitude": "-122.8311976",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfS4vUsPlVQRVYCbJB05hN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ce4ff5d6-7b91-480b-9e5e-d5d110be4dab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "AWS Elemental (PDX13)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1320 SW Broadway #400, Portland, OR 97201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12779097230135987545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "aws-elemental-pdx13",
      "poi_latitude": "45.5148856",
      "poi_longitude": "-122.6814735",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-222-3212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVQ2NMwLlVQRWQ1vaDl5WLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bd0d9f91-b2bf-4f8e-8748-d01288716c71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "poi_name": "Nike - Seb Coe",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Beaverton, OR 97006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ac-3d21-750f-b59c-58ef22e34b8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-3d21-750f-b59c-58ef22e34b8c",
        "storage_key": "property/6767906449166885/019d08ac-3d21-750f-b59c-58ef22e34b8c.webp",
        "width": 805,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6550842833509833011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nike---seb-coe",
      "poi_latitude": "45.5120496",
      "poi_longitude": "-122.8291215",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a152-7578-b959-665a64655a52",
        "storage_key": "property/6767906449166885/019d08ab-a152-7578-b959-665a64655a52.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHyGamtwOlVQRM1nEZtlE6Vo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_f4f78504-c0fe-4518-857a-855a88df3bfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_b14ebe76-45f2-4aa3-8ad9-ad19faf381f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_a0d98009-bbdb-4eba-827a-31ea8a4c2f5d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_a0ec71b9-ae90-4b87-84a5-fc6993498eec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_61455c69-4a99-40cc-af27-211cd3f95490",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_7d300fd4-21c4-4b50-9439-2567d3a95232",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_c03efe5b-2833-4446-a76f-da82264c0b81",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_853bbfdde1c6cf07db812ece",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "rating": "4",
      "name": "Brendan",
      "text": "A little worn down and old inside with maintenance problems like a lot of comments have been saying. There was a very very slight mold problem in the bathroom. There isn't much to the complex and the storage units weren't available although they are still advertised as available.\n\nWith that being said, the price is not bad at all considering you'll most likely be paying just as much in any other part of town for the amount of space, but here you won't be living around crackheads and rude people.\n\nApartments are located in a very nice part of town on the westside. Feels much safer and nice to live in in general than many other parts of town. Majority of the people in the complex and Garden Home neighborhood are friendly and courteous (not to mention insurance rates and crime is much lower in SW). The Garden Home marketplace with a Starbucks, Great Clips, Shari's, etc is conveniently located about 50 feet from the apartments which is a HUGE plus.\n\nManagement was courteous and had no problems with getting back deposit money or being overcharged for that or rent.",
      "date": "2019-04-11",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_73a9345c-a1b4-48bd-addf-6788fb232ffe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d2afa-6b8a-7188-a1da-61b5a8a4d115.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2afa-6b8a-7188-a1da-61b5a8a4d115",
        "storage_key": "property/6767906449166885/019d2afa-6b8a-7188-a1da-61b5a8a4d115.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Garden Glen Apartments - Upgraded 2 Bedroom 1 Bath 776 sq. ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=q9WGJWau4LV"
    },
    {
      "id": "custom_620ce01c-cd9a-4fb7-ab41-aadfe84a87d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166885/019d2afa-86ad-75a2-b4a6-6271690576d7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2afa-86ad-75a2-b4a6-6271690576d7",
        "storage_key": "property/6767906449166885/019d2afa-86ad-75a2-b4a6-6271690576d7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Cedar Lane Apartments - Upgraded 1 Bed 1 Bath 544 sq. ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Nx9QWzYwQFp"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db12d-82f7-7516-b7df-a598e0339f15",
      "lead_source": "LANDING_PAGE",
      "name": "Cedar Lane and Garden Glen Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "generator",
      "page_item_url": "cedarlane-gardenglen-apartments-with-dishwasher",
      "search_query": "apartments with dishwasher Portland",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Portland",
      "h2_subtitle": "Discover modern living at Cedar Lane/Garden Glen, offering spacious apartments with dishwasher amenities in the heart of Portland.",
      "page_copy": "Looking for an apartment in Portland that combines convenience with comfort? Cedar Lane/Garden Glen has you covered with our spacious units featuring built-in dishwashers. Situated in the welcoming Ashcreek neighborhood, our community offers an array of amenities designed for seamless living. Enjoy high-speed internet access, balconies or patios, and the convenience of on-site laundry facilities. \n\nAt Cedar Lane/Garden Glen, each apartment is thoughtfully designed to enhance your lifestyle. The inclusion of dishwashers in every unit makes daily chores a breeze, allowing you more time to enjoy the vibrant Portland life. Whether you're relaxing on your balcony or taking advantage of the walk-up access, our apartments provide an ideal sanctuary in Washington County. Experience the perfect blend of city life and suburban comfort here at Cedar Lane/Garden Glen.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Lane Apartments with Dishwasher",
      "seo_description": "Explore Cedar Lane in Portland, offering apartments with dishwasher facilities, balconies, and more in a vibrant setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "generator",
      "page_item_url": "cedarlane-gardenglen-high-speed-internet",
      "search_query": "high speed internet access apartments Ashcreek",
      "category": "Amenity",
      "h1_title": "High Speed Internet Apartments in Ashcreek",
      "h2_subtitle": "Discover the convenience of high speed internet access in Ashcreek's Cedar Lane/Garden Glen apartments.",
      "page_copy": "Cedar Lane/Garden Glen in the Ashcreek neighborhood of Portland offers apartments that come with high speed internet access as a standard. This essential amenity ensures that whether you're working from home or streaming your favorite shows, you'll always have a connection you can rely on. Our apartments are not only tech-friendly but also boast features like walk-up access, private patios, and balconies, making them ideal for modern lifestyles.\n\nLocated in the vibrant city of Portland, Cedar Lane/Garden Glen stands out with its fusion of technology and comfort. Each apartment is equipped with high speed internet access, catering perfectly to the needs of professionals and entertainment enthusiasts alike. Paired with on-site laundry facilities and lush community spaces, our Washington County location offers the perfect mix of suburban tranquility and city convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ashcreek Apartments with High Speed Internet",
      "seo_description": "Find high speed internet access apartments at Cedar Lane in Ashcreek, offering modern amenities for a connected lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "generator",
      "page_item_url": "cedarlane-gardenglen-smoke-free-apartments",
      "search_query": "smoke free apartments Washington County",
      "category": "Amenity",
      "h1_title": "Smoke Free Apartments in Washington County",
      "h2_subtitle": "Enjoy a healthy lifestyle at Cedar Lane/Garden Glen's smoke free apartments in Washington County.",
      "page_copy": "Cedar Lane/Garden Glen is proud to offer smoke free apartments in the scenic Washington County area. Our community prioritizes the well-being of all residents by maintaining a smoke-free environment, ensuring a healthier living space. Nestled in Portland's Ashcreek neighborhood, our apartments provide the perfect blend of modern amenities and tranquility.\n\nIn addition to our smoke-free policy, Cedar Lane/Garden Glen features high-speed internet access, thoughtfully designed walk-ups, and spacious balconies or patios. With on-site laundry facilities, our community is designed for ease and comfort, making it a top choice in Washington County. Experience the peace of mind that comes with living in a smoke-free community, surrounded by Portland's vibrant cultural and recreational opportunities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke Free Apartments in Washington County",
      "seo_description": "Explore smoke free apartments at Cedar Lane in Washington County, featuring modern amenities and a healthy living environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "generator",
      "page_item_url": "cedarlane-gardenglen-apartment-with-patio",
      "search_query": "apartment with patio Portland OR",
      "category": "Amenity",
      "h1_title": "Apartment with Patio in Portland, OR",
      "h2_subtitle": "Find your serene retreat in Portland, OR with an apartment featuring a private patio at Cedar Lane/Garden Glen.",
      "page_copy": "Experience the best of outdoor living at Cedar Lane/Garden Glen, where each apartment in Portland, OR features a tranquil patio. These outdoor spaces are perfect for morning coffee or evening relaxation, seamlessly extending your living area into the fresh air. Located in the peaceful Ashcreek neighborhood, our community offers a perfect blend of urban accessibility and suburban comfort.\n\nAt Cedar Lane/Garden Glen, residents enjoy more than just a private patio. With amenities like high-speed internet access, convenient walk-ups, and on-site laundry facilities, our apartments are designed to cater to a modern lifestyle. Discover why our Portland, OR community in Washington County is the ideal place to call home, offering both indoor and outdoor living pleasures.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Portland Apartments with Patio",
      "seo_description": "Discover Cedar Lane in Portland, OR, where each apartment offers a private patio, blending urban flair with comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "generator",
      "page_item_url": "cedarlane-gardenglen-kitchen-amenities",
      "search_query": "apartment kitchen amenities 97223",
      "category": "Amenity",
      "h1_title": "Apartment Kitchen Amenities in 97223",
      "h2_subtitle": "Explore the superior kitchen amenities at Cedar Lane/Garden Glen apartments, located in the 97223 ZIP code.",
      "page_copy": "Cedar Lane/Garden Glen apartments offer a comprehensive suite of kitchen amenities, making meal preparation and everyday living enjoyable in Portland's 97223 ZIP code. Our apartments feature modern kitchens that cater to all your culinary needs, ensuring a comfortable cooking experience. The kitchen's thoughtful layout and quality features contribute to the overall convenience and comfort of each home.\n\nLocated in the Ashcreek neighborhood, our apartments are ideally situated in Washington County, providing easy access to local dining and shopping. Cedar Lane/Garden Glen not only highlights its superior kitchen amenities but also offers community features such as high-speed internet, private patios, and convenient laundry facilities, making it an exceptional choice for those seeking a well-rounded living environment in Portland.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "97223 Apartments with Kitchen Amenities",
      "seo_description": "Find top kitchen amenities at Cedar Lane in the 97223 area, offering ideal cooking spaces in a vibrant Portland community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "generator",
      "page_item_url": "cedarlane-gardenglen-one-bedroom-ashcreek",
      "search_query": "one bedroom apartments near Ashcreek",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near Ashcreek",
      "h2_subtitle": "Discover comfortable one bedroom apartments near Ashcreek at Cedar Lane/Garden Glen, where convenience meets community charm.",
      "page_copy": "Cedar Lane/Garden Glen offers inviting one bedroom apartments near Ashcreek, a charming neighborhood in Portland known for its serene surroundings and local amenities. Our one-bedroom layouts provide spacious living areas that are perfectly suited for singles or couples seeking comfortable living in a prime location. Each apartment is equipped with modern conveniences designed to complement a busy lifestyle.\n\nThe community is nestled in Washington County, offering residents easy access to the beauty of the Pacific Northwest while being close to Portland's vibrant downtown. Amenities such as high-speed internet, private balconies, walk-up access, and on-site laundry facilities enrich the living experience. Make Cedar Lane/Garden Glen your new home and enjoy the perfect balance of tranquility and accessibility near Ashcreek.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near Ashcreek",
      "seo_description": "Find cozy one-bedroom apartments near Ashcreek at Cedar Lane, blending comfort and convenience in a serene Portland community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "generator",
      "page_item_url": "cedarlane-gardenglen-two-bedroom-portland",
      "search_query": "two bedroom apartments Portland OR",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Portland, OR",
      "h2_subtitle": "Spacious two bedroom apartments await you in Portland, OR at Cedar Lane/Garden Glen, offering ample space and modern amenities.",
      "page_copy": "Cedar Lane/Garden Glen presents spacious two bedroom apartments in Portland, OR, ideal for families, roommates, or those in need of extra space. Our thoughtfully designed floor plans provide ample living areas, ensuring that every resident can enjoy both privacy and comfort. The property's location in Ashcreek combines the tranquility of a suburban environment with easy access to Portland's urban attractions.\n\nResidents at Cedar Lane/Garden Glen benefit from a wide range of amenities, including high-speed internet access, walk-up convenience, and private patios or balconies. Situated in Washington County, our community is perfectly placed for exploring local parks, shopping, and dining. Come home to Cedar Lane/Garden Glen and experience the ideal blend of space, comfort, and community in Portland, OR.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Portland, OR",
      "seo_description": "Explore two bedroom apartments at Cedar Lane in Portland, OR, offering spacious living with modern amenities in a great community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166885",
      "source": "generator",
      "page_item_url": "cedarlane-gardenglen-three-bedroom-washington-county",
      "search_query": "three bedroom apartments Washington County",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Washington County",
      "h2_subtitle": "Discover spacious three bedroom apartments in Washington County at Cedar Lane/Garden Glen, perfect for families and individuals seeking ample living space.",
      "page_copy": "Cedar Lane/Garden Glen offers generous three bedroom apartments located in Washington County, ideal for those seeking a large, versatile living environment. Our apartments are designed with families and individuals in mind, providing room to live, work, and relax comfortably. Enjoy the convenience of our modern amenities while situated in the peaceful Ashcreek neighborhood of Portland, OR.\n\nOur community features high-speed internet, private balconies, and easy walk-up access, enhancing your everyday living experience. Washington County offers a balance of natural beauty and urban conveniences, with parks, shopping, and dining nearby. Choose Cedar Lane/Garden Glen for your next home, where spacious living meets community charm in the heart of Portland's vibrant region.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Washington County",
      "seo_description": "Find spacious three-bedroom options at Cedar Lane in Washington County, perfect for families and individuals in a great community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "brianna@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372405521"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "\tGTM-M5L8KRM6"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-494-2483 "
    }
  ],
  "custom_csm": "brianna@repli360.com",
  "custom_repli_id": "18372405521",
  "custom_google_gtm_id": "\tGTM-M5L8KRM6",
  "custom_ads_subscription": "essential",
  "custom_seo_subscription": "none",
  "custom_social_subscription": "none",
  "custom_website_subscription": "none",
  "custom_ppc_tracking_phone_number": "844-494-2483 "
};

export const generatedAt = '2026-10-22T14:57:50.621Z';
